const arrowForward = document.querySelector("#reviewSlideForward");
const arrowBack = document.querySelector("#reviewSlideBack");

const review_container = document.getElementById('reviewSliderContainer');
const reviewCardWidth = document.querySelector('.review-card').scrollWidth;
const totalReviewCards = document.getElementsByClassName('review-card').length;
const totalScrollWidth = (reviewCardWidth + 15 * deviceCards()) * totalReviewCards;

$(window).resize(() => {
  toggleScrolling(0);
});

arrowForward.addEventListener('click', () => {
  toggleScrolling(review_container.scrollLeft + (reviewCardWidth + 15 * deviceCards()) * deviceCards());
});

arrowBack.addEventListener('click', () => {
  if(review_container.scrollLeft != 20) {
    toggleScrolling(review_container.scrollLeft - (reviewCardWidth + 15 * deviceCards()) * deviceCards());
  } else {
    toggleScrolling(totalScrollWidth);
  }
})

function toggleScrolling(scrollBy) {
  review_container.scroll({
    top: 0,
    left: scrollBy,
    behavior: "smooth"
  });
}

function deviceCards() {
  if(this.innerWidth > 990) {
    return 3; //3 cards for desktop view
  }else if (this.innerWidth <= 990 && this.innerWidth > 750) {
    return 2; //2 for tablet
  } else {
    return 1; //1 for mobile
  }
}